import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchAdjustmentRequestDetail = createAsyncThunk(
  "fetchAdjustmentRequestDetail",
  async (id) => {
    const token = localStorage.getItem("auth_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(
      `adjustment-request/${id}`,
      config
    );

    return response.data.data;
  }
);

const adjustmentRequestDetailSlice = createSlice({
  name: "adjustmentRequestDetail",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchAdjustmentRequestDetail.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchAdjustmentRequestDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });

    builder.addCase(fetchAdjustmentRequestDetail.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default adjustmentRequestDetailSlice.reducer;
